import React from 'react';
import { Link } from 'react-router-dom';
import 'flag-icons/css/flag-icons.min.css';

function AircraftCard({ aircraft }) {
  return (
    <Link to={`/aircraft/${aircraft.id}`} className="aircraft-card">
      <div className="card-content">
        <h3 className="card-title">{aircraft.name}</h3>

        <div className="card-info">
          <div className="info-row">
            <span className="info-label">Manufacturer</span>
            <span className="info-value">{aircraft.manufacturer}</span>
          </div>

          <div className="info-row">
            <span className="info-label">Country</span>
            <span className="info-value">
              <span className={`fi fi-${aircraft.countryCode} flag-icon`}></span>
              {aircraft.country}
            </span>
          </div>

          <div className="info-row">
            <span className="info-label">Type</span>
            <span className="info-value">{aircraft.type}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default AircraftCard;
